import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { EditionShell } from "../components/dnh/feed/EditionShell";
import { NewsFeed } from "../components/dnh/feed/NewsFeed";

export default function Category() {
  const { slug } = useParams(); const [params] = useSearchParams();
  const name = slug.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());
  return <EditionShell title={name} activeNav="Explore" testId="category-page">
    <NewsFeed key={`${slug}:${params.get("country") || ""}`} category={slug} country={params.get("country") || undefined} title={name} />
  </EditionShell>;
}